import { useThemeContext } from '../../../contexts/Theme-Context';
import React, { useEffect, useRef, useState } from 'react';
import Spinner from '../../utils/spinner/Spinner';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5stock from "@amcharts/amcharts5/stock";
import am5themes_Dark from '@amcharts/amcharts5/themes/Material';
import am5themes_Responsive from '@amcharts/amcharts5/themes/Responsive';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

import { API_ENDPOINT_KLINES_MT } from '../../../data/Endpoints-API';
import { useSymbolContext } from '../../../contexts/Symbol-Context';
import { useAuthContext } from '../../../contexts/Auth-Context';
import { useChartContext } from '../../../contexts/Chart-Context';
// import '../../../themes/old-dark.scss'
// import '../../../themes/dark.scss'
// import './Chart.scss';
import './Chart-Toolbar.scss';
import './am5stockChart.scss'
import { useAccountManagerContext } from '../../../contexts/Account-Manager-Context';
import { eaChartToolbarReady, eaChartToolbarTeardown } from '../ea/eaApi.js';

const DRAW_SUBTOOLBAR_NUDGE = 8;
// Same icon spacing whether the sidebar list scrolls or not, so hover targets
// stay readable on short charts without the layout jumping when it grows.
const DRAW_SIDEBAR_GAP = 10;

const Chart = ({ mobileMode }) => {
  const { theme } = useThemeContext();
  const chartColors = theme === 'light'
    ? { bg: '#edf1f6', panel: '#fcfcfd', text: '#202c3c', muted: '#718096' }
    : { bg: '#1a1f36', panel: '#252b42', text: '#e8eaf0', muted: '#b8bcc8' };
  // Context
  const {
    clickedPosition,
    showTooltip,
    setShowTooltip,
    showBullets,
    loadingSymbolContext,
    symbolNames,
    updateSymbolName,
    symbolInfo,
    updateSymbolDetailsData,
    setSelectedCategoryId,
    symbolWithCategories,
    setSelectedSymbolSession,
  } = useSymbolContext();
  const {
    user,
    platFromData,
    selectedAuthSymbol,
    selectedAuthSymbolId,
    setAuthSelectedSymbol,
    setAuthTimeFrame,
    setAuthSelectedCategory,
    defaultSelectedCategory,
    isReconnected, 
    setIsReconnected
  } = useAuthContext();
  const {
    selectedTimeFrame,
    updateChartTimeFrame,
    // selectedSeriesType,
    zoomRange,
    setLineCandle,
    selectedStyle, 
    setSelectedStyle, 
    styleOptions,
  } = useChartContext();
  const { openPositions, closedPositions , closedPositionsAll} = useAccountManagerContext();
  

  const chartRef = useRef(null);
  const mainPanelRef = useRef(null);
  const valueSeriesRef = useRef(null);
  const cleanupRef = useRef(null);
  let timeFrameChartSetup = 'minute';

  timeFrameChartSetup = (selectedTimeFrame === '1m' || selectedTimeFrame === '5m' || selectedTimeFrame === '15m' || selectedTimeFrame === '30m') 
  ? 'minute'
  : (selectedTimeFrame === '1h' || selectedTimeFrame === '4h') 
      ? 'hour'
      : (selectedTimeFrame === '1d') 
          ? 'day' 
          : 'minute'

  const numberFormat = '#,#### ';

  // useEffect(() => {
  //   if (clickedPosition) {
  //     createChartBulletClosePosition(clickedPosition);
  //   }
  // }, [clickedPosition]);
  
  

  useEffect(() => {
    if (selectedAuthSymbol !== '') {
      updateSymbolDetailsData(selectedAuthSymbol);
    }
  }, [selectedAuthSymbol]);

  //local states
  let [stockChart2, setStockChart2] = useState(null);
  let [currentLabel2, setCurrentLabel2] = useState(null);
  let [currentLabelNew2, setCurrentLabelNew2] = useState(null);
  let [currentValueDataItem2, setCurrentValueDataItem2] = useState(null);
  let [currentValueDataItemNew, setCurrentValueDataItemNew] = useState(null);
  
  const [chartInitialized, setChartInitialized] = useState(false);


  let [dataReady, setDataReady] = useState(false);
  const allChartDataRef = useRef([]);
  const currentChartDataRef = useRef([]);

  let root = null;
  let currentLabel = null;
  let currentLabelNew = null;
  let currentValueDataItem = null;
  let candleLength = 450;

  // useEffect to handle component lifecycle
  useEffect(() => {
    //nothing will load in this component until SymbolContext fully loaded
    if (!loadingSymbolContext) {
        // Clean up previous listeners
        if (cleanupRef.current) {
          cleanupRef.current();
        }
        // Setup chart and store cleanup function
        cleanupRef.current = chartSetup();
    }
    
    // Cleanup on unmount or dependency change
    return () => {
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = null;
      }
    };
  }, [loadingSymbolContext, selectedAuthSymbol, selectedTimeFrame, showTooltip, showBullets, theme]);
  
  useEffect(() => {
    // Only run if colors changed and chart container exists
    if (document.getElementById('chartdiv')) {
      // Clean up previous listeners
      if (cleanupRef.current) {
        cleanupRef.current();
      }
      // Setup chart and store cleanup function
      cleanupRef.current = chartSetup();
    }
  }, [selectedStyle.buyColor, selectedStyle.sellColor]);
  
  useEffect(() => {
    
    // console.log("triggered ppostions");
    if (openPositions.length > 0 || selectedAuthSymbol || selectedTimeFrame) {
      createChartBullets();
    }
  }, [openPositions.length, selectedAuthSymbol, selectedTimeFrame, showBullets , showTooltip]);


  useEffect(() => {
    // console.log("Symbol or Timeframe changed, clearing bullets");

    greenBullets.forEach((bullet) => bullet.dispose());
    greenBullets = []; // Reset the array
    
    greenBullets2.forEach((bullet) => bullet.dispose());
    greenBullets2 = [];
  
    persistentBullets.forEach((bullet) => bullet.dispose());
    persistentBullets = [];
  
    createChartBullets();
    createChartBullets2();
    createPersistentBullets();
  }, [selectedAuthSymbol, selectedTimeFrame]);
  
  

  // useEffect(() => {
  //   if (clickedPosition || selectedAuthSymbol || selectedTimeFrame) {
  //     createChartBulletClosePosition(clickedPosition); // Orange bullet
  //   }
  // }, [clickedPosition, selectedAuthSymbol, selectedTimeFrame, showBullets , showTooltip])
  

  useEffect(() => {
    if (closedPositionsAll.length > 0 || selectedAuthSymbol || selectedTimeFrame) {
      
      createChartBullets2(); // Orange bullet
    }
  }, [closedPositionsAll.length, selectedAuthSymbol, selectedTimeFrame, showBullets , showTooltip])


  useEffect(() => {
    if (closedPositionsAll.length > 0 || selectedAuthSymbol || selectedTimeFrame) {
      createPersistentBullets();
    }
  }, [closedPositionsAll.length, selectedAuthSymbol, selectedTimeFrame, showBullets]);
  


  // useEffect to handle component lifecycle after reconnection
  useEffect(() => {
    //nothing will load in this component until SymbolContext fully loaded
    if (isReconnected) {
        // console.log("Dependencies in if:", { isReconnected });
        // Clean up previous listeners
        if (cleanupRef.current) {
          cleanupRef.current();
        }
        // Setup chart and store cleanup function
        cleanupRef.current = chartSetup();
        if (openPositions.length > 0) {
          createChartBullets();
        }
    }
  }, [isReconnected]);

  // useEffect(() => {
  //   if (
  //     !loadingSymbolContext &&
  //     chartRef?.current &&
  //     valueSeriesRef?.current &&
  //     chartLoadedFirstTime
  //   ) {
  //     debugger;
  //     loadChartData(valueSeriesRef?.current);
  //   }
  // }, [selectedAuthSymbol, selectedTimeFrame]);

  useEffect(() => {
    //nothing will load in this component until SymbolContext fully loaded
    if (!loadingSymbolContext && dataReady) {
      updateLiveFeedData();
    }
  }, [platFromData[1]], dataReady);

  //dispose root if there is any because only root could exists
  const maybeDisposeRoot = (divId) => {
    am5.array.each(am5.registry.rootElements, function (root) {
      if (root.dom.id === divId) {
        root.dispose();
      }
    });
  };

  // Main chart setup function
  const chartSetup = () => {
    // Pull the Strategy host out of #chartcontrols before amCharts wipes it
    // (style change, symbol, TF, bullets — same crash as the old MutationObserver).
    eaChartToolbarTeardown();

    //dispose root if there is any because only root could exists
    maybeDisposeRoot('chartdiv');

    //#region CHART SETUP
    root = am5.Root.new('chartdiv');

    var indicator = root.container.children.push(am5.Container.new(root, {
      width: am5.p100,
      height: am5.p100,
      layer: 1000,
      background: am5.Rectangle.new(root, {
        fill: am5.color(chartColors.bg), // Updated to match theme $bodyColor
        fillOpacity: 0.9
      })
    }));

    indicator.children.push(am5.Label.new(root, {
      text: "Loading...",
      fontSize: 25,
      x: am5.p50,
      y: am5.p50,
      centerX: am5.p50,
      centerY: am5.p50,
      fill: am5.color(0x808080)
    }));
    let hourglass = indicator.children.push(am5.Graphics.new(root, {
      width: 32,
      height: 32,
      fill: am5.color(0x808080),
      x: am5.p50,
      y: am5.p50,
      centerX: am5.p50,
      centerY: am5.p50,
      dy: -45,
      svgPath: "M12 5v10l9 9-9 9v10h24V33l-9-9 9-9V5H12zm20 29v5H16v-5l8-8 8 8zm-8-12-8-8V9h16v5l-8 8z"
    }));
    var hourglassanimation = hourglass.animate({
      key: "rotation",
      to: 180,
      loops: Infinity,
      duration: 2000,
      easing: am5.ease.inOut(am5.ease.cubic)
    });


    hourglassanimation.play();
    indicator.show();

    // The following line removes the AMCharts logo even in the free version. BUT THIS IS AGAINST THEIR LICENSE AGREEMENT.
    root._logo.dispose();

    //custom theme
    const myTheme = am5.Theme.new(root);

    myTheme.rule('Grid').setAll({
      stroke: am5.color(theme === 'light' ? '#aab7c8' : 0x808080),
      strokeWidth: 1,
    });

    myTheme.rule('Label').setAll({
      fill: am5.color(chartColors.text), // Updated to match theme $boldTextColor
    });

    // Keep StockLegend cards solid/sharp for MA + RSI alike (default theme uses shadowBlur:5).
    // Match without requiring "stocklegend" on the background sprite — that tag is not always
    // present on item backgrounds, which left overlay MA cards soft over candles.
    myTheme.rule('RoundedRectangle', ['legend', 'itemcontainer', 'background']).setAll({
      fill: am5.color(chartColors.panel),
      fillOpacity: 1,
      shadowBlur: 0,
      shadowOpacity: 0,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
    });
    myTheme.rule('RoundedRectangle', ['legend', 'itemcontainer', 'background', 'stocklegend']).setAll({
      fill: am5.color(chartColors.panel),
      fillOpacity: 1,
      shadowBlur: 0,
      shadowOpacity: 0,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
    });
    myTheme.rule('Label', ['legend']).setAll({
      fill: am5.color(chartColors.text),
      opacity: 1,
    });
    myTheme.rule('Label', ['legend', 'stocklegend']).setAll({
      fill: am5.color(chartColors.text),
      opacity: 1,
    });
    myTheme.rule('Label', ['legend', 'value', 'label', 'stocklegend']).setAll({
      fill: am5.color(chartColors.text),
      opacity: 1,
    });

    // Price-based overlay indicators default to #.00 — too coarse for FX (shows 1.17
    // instead of 1.16520). Match the active symbol's digit count.
    const priceDigits = Math.max(0, Number(symbolInfo?.digit) || 5);
    const priceLegendFmt = `#.${'0'.repeat(priceDigits)}`;
    const priceLegendValue = `[{seriesColor} bold]{valueY.formatNumber('${priceLegendFmt}')}[/]`;
    myTheme.rule('LineSeries', ['movingaverage']).setAll({
      legendValueText: priceLegendValue,
    });
    myTheme.rule('LineSeries', ['bollingerbands']).setAll({
      legendValueText: `[{lowerColor} bold]{lower.formatNumber('${priceLegendFmt}')}[/] [{seriesColor} bold]{valueY.formatNumber('${priceLegendFmt}')}[/] [{upperColor} bold]{upper.formatNumber('${priceLegendFmt}')}[/]`,
    });
    myTheme.rule('LineSeries', ['indicator', 'movingaverageenvelope']).setAll({
      legendValueText: `[{lowerColor} bold]{lower.formatNumber('${priceLegendFmt}')}[/] [{seriesColor} bold]{valueY.formatNumber('${priceLegendFmt}')}[/] [{upperColor} bold]{upper.formatNumber('${priceLegendFmt}')}[/]`,
    });
    myTheme.rule('LineSeries', ['vwap']).setAll({
      legendValueText: priceLegendValue,
    });
    myTheme.rule('LineSeries', ['supertrend']).setAll({
      legendValueText: priceLegendValue,
    });

    myTheme.rule('Button', ['control', 'settings']).setAll({
      stateAnimationDuration: 0,
      interpolationDuration: 0,
    });
    myTheme.rule('Button', ['control', 'settings']).states.create('default', {
      stateAnimationDuration: 0,
    });
    myTheme.rule('Button', ['control', 'settings']).states.create('hover', {
      stateAnimationDuration: 0,
    });
    myTheme.rule('Graphics', ['settings', 'button', 'icon']).setAll({
      stroke: am5.color('#8b92b0'),
      fill: am5.color(chartColors.panel),
      fillOpacity: 1,
      strokeOpacity: 0.85,
      strokeWidth: 0.5,
      stateAnimationDuration: 0,
      interpolationDuration: 0,
    });
    myTheme.rule('Graphics', ['settings', 'button', 'icon']).states.create('default', {
      stateAnimationDuration: 0,
    });
    myTheme.rule('Graphics', ['control', 'button', 'icon']).states.create('hover', {
      stroke: am5.color(chartColors.text),
      fill: am5.color(chartColors.panel),
      fillOpacity: 1,
      strokeOpacity: 1,
      stateAnimationDuration: 0,
    });

    // Stock controls default to half opacity, which washes out on a light plot.
    myTheme.rule('PanelControls').set('opacity', 1);
    myTheme.rule('Graphics', ['control', 'button', 'icon']).setAll({
      stroke: am5.color(chartColors.muted),
      strokeOpacity: 1,
    });
    myTheme.rule('Graphics', ['settings', 'button', 'icon']).setAll({
      stroke: am5.color(chartColors.muted),
      strokeOpacity: 1,
      strokeWidth: 1,
    });

    // Set themes
    root.setThemes(
      mobileMode
        ? [am5themes_Responsive.new(root), am5themes_Dark.new(root), myTheme]
        : [am5themes_Animated.new(root), am5themes_Dark.new(root), myTheme],
    );

    // Keep default canvas controls and axis masks on the same surface as the plot.
    root.interfaceColors.setAll({
      background: am5.color(chartColors.bg),
      alternativeBackground: am5.color(chartColors.panel),
      text: am5.color(chartColors.text),
      alternativeText: am5.color(chartColors.text),
      secondaryButton: am5.color(chartColors.bg),
      secondaryButtonText: am5.color(chartColors.muted),
    });
    root.container.set("background", am5.Rectangle.new(root, {
      fill: am5.color(chartColors.bg) // Updated to match theme $bodyColor
    }));

    //#region Create a stock chart
    let stockChart = root.container.children.push(
      am5stock.StockChart.new(root, {
        stockNegativeColor: am5.color(selectedStyle.sellColor),
        stockPositiveColor: am5.color(selectedStyle.buyColor),
      }),
    );

    setStockChart2(stockChart);

    // Set global number format
    root.numberFormatter.set('numberFormat', numberFormat);

    let mainPanel = stockChart.panels.push(
      am5stock.StockPanel.new(root, {
        panX: true,
        panY: true,
        wheelX: 'panX',
        wheelY: 'zoomX',
        pinchZoomX: true,
        paddingTop: 28,
      }),
    );

    // Create value/vertical axis
    let valueAxis = mainPanel.yAxes.push(
      am5xy.ValueAxis.new(root, {
        start: 0.9, //show 10% candles on load
        renderer: am5xy.AxisRendererY.new(root, {
          pan: 'zoom',
          crisp: true,
          stroke: am5.color(chartColors.panel), // Updated to match theme $firstBox
          strokeOpacity: 1,
          strokeWidth: 1,
        }),
        extraMin: 0.1, // adds some space for for main series
        extraMax: 0.4, // adds some space for for main series
        tooltip: am5.Tooltip.new(root, {}),
        numberFormat: numberFormat,
        // maxPrecision: 8,
        // extraTooltipPrecision: 4,
      }),
    );

    // Create date/horizontal axis
    let dateAxis = mainPanel.xAxes.push(
      am5xy.GaplessDateAxis.new(root, {
        start: zoomRange || 0.9, //show 10% candles on load
        minZoomCount: mobileMode ? 30 : 10,
        baseInterval: {
          timeUnit: timeFrameChartSetup,
          count: selectedTimeFrame === '15m' || selectedTimeFrame === '30m' ? 5 : 1,
        },
        renderer: am5xy.AxisRendererX.new(root, {
          pan: 'zoom',
          stroke: am5.color(chartColors.panel), // Updated to match theme $firstBox
          strokeOpacity: 1,
          strokeWidth: 1,
          minGridDistance: mobileMode ? 50 : 80,
          // minorGridEnabled: true,
        }),
        crisp: true,
        tooltip: am5.Tooltip.new(root, {}),
        end: 1.1, // increase the end value to add space on the right side
      }),
    );

      if (!mobileMode) {
        // dateAxis.set("dateFormats", {
        //     minute: "HH:mm", // Format for minutes
        //     hour: "HH:mm",
        //     day: "MMM dd",
        // });
        dateAxis.set("periodChangeDateFormats", {
            minute: "[bold]MMM dd",
            hour: "[bold]MMM dd",
            day: "[bold]MMM dd",
        });
    }


    // add range which will show current value
    currentValueDataItem = valueAxis.createAxisRange(
      valueAxis.makeDataItem({ value: 0 }),
    );

    currentValueDataItemNew = valueAxis.createAxisRange(
      valueAxis.makeDataItem({ value: 0 }),
    );
    setCurrentValueDataItemNew(currentValueDataItemNew);

    setCurrentValueDataItem2(currentValueDataItem);

    // currentValueDataItem.get('label').set('visible', false);
    // currentValueDataItemNew.get('label').set('visible', false);

    currentLabel = currentValueDataItem.get('label');
    currentLabelNew = currentValueDataItemNew.get('label');

    setCurrentLabelNew2(currentLabelNew);
    setCurrentLabel2(currentLabel);
  //   if (currentLabelNew) {
  //     currentLabelNew.setAll({
  //       fill: am5.color(0xffffff),
  //       background: am5.Rectangle.new(root, { fill: am5.color(0x000000) }),
  // fillOpacity: 0.5
  //     });
  //   }
  //   if (currentLabel) {
  //     currentLabel.setAll({
  //       fill: am5.color(0xffffff),
  //       background: am5.Rectangle.new(root, { fill: am5.color(0x000000) }),
  //     });
  //   }


  if (currentLabelNew) {
  currentLabelNew.setAll({
    fill: am5.color(chartColors.text), // Updated to match theme $boldTextColor
    background: am5.Rectangle.new(root, {
      fill: am5.color(chartColors.bg), // Updated to match theme $bodyColor
      fillOpacity: 0.7, // Semi-transparent for better readability
      minWidth: 60, // Limit width to prevent overflow
      // cornerRadius: 5, // Rounded corners
    }),
    dy: -13, // Adjust vertical position to stack above
  });
}

if (currentLabel) {
  currentLabel.setAll({
    fill: am5.color(chartColors.text), // Updated to match theme $boldTextColor
    background: am5.Rectangle.new(root, {
      fill: am5.color(chartColors.bg), // Updated to match theme $bodyColor
      fillOpacity: 0.7, // Semi-transparent
      minWidth: 60
      // cornerRadius: 15, // Rounded corners
    }),
    dy: 0, // Base position
  });
}

    let currentGridNew = currentValueDataItemNew.get('grid');
    let currentGrid = currentValueDataItem.get('grid');

    if (currentGridNew) {
      currentGridNew.setAll({
        stroke: am5.color(selectedStyle.buyColor),
        strokeOpacity: 0.5,
        // strokeDasharray: [2, 5]
      });
    }

    if (currentGrid) {
      currentGrid.setAll({
        stroke: am5.color(selectedStyle.sellColor),
        strokeOpacity: 1,
      });
    }

//     const chart = valueAxis.chart; // Get the chart instance
// const plotContainer = chart.plotContainer;

// Function to create a label at a specific price
// function createPriceLabel(price, text, color, dyOffset) {
//   const yPosition = valueAxis.valueToPosition(price); // Convert price to y-position
//   const label = am5.Label.new(root, {
//     text: text,
//     fill: am5.color(0xffffff), // White text
//     x: am5.percent(5), // Position the label slightly inside the chart (adjust as needed)
//     y: yPosition, // Y-position based on price
//     dy: dyOffset, // Offset to stack labels
//     centerY: yPosition, // Align vertically with the price level
//     background: am5.Rectangle.new(root, {
//       fill: am5.color(color), // Background color (e.g., green for bid, red for ask)
//       fillOpacity: 0.7,
//       cornerRadius: 5,
//     }),
//     paddingLeft: 5,
//     paddingRight: 5,
//     paddingTop: 2,
//     paddingBottom: 2,
//   });

//   plotContainer.children.push(label);
//   return label;
// }

// // Create labels for ask and bid prices
// const bidLabel = createPriceLabel(
//   4.854,
//   `Bid: 134`,
//   selectedStyle.sellColor, // Use your bid color
//   0 // No offset for bid
// );

// const askLabel = createPriceLabel(
//   4.855,
//   `Ask: 123`,
//   selectedStyle.buyColor, // Use your ask color
//   -20 // Offset ask label above bid
// );

// Optional: Update labels dynamically if prices change
// function updateLabels(newAskPrice, newBidPrice) {
//   const newAskY = valueAxis.valueToPosition(newAskPrice);
//   const newBidY = valueAxis.valueToPosition(newBidPrice);

//   askLabel.set('y', newAskY);
//   askLabel.set('centerY', newAskY);
//   askLabel.set('text', `Ask: ${newAskPrice}`);

//   bidLabel.set('y', newBidY);
//   bidLabel.set('centerY', newBidY);
//   bidLabel.set('text', `Bid: ${newBidPrice}`);
// }

    // Add series
    let valueSeries;
    let volumeSeries;
    var tooltip;
    const textColor = am5.color(chartColors.text) // Updated to match theme $boldTextColor

    if (showTooltip) {
    tooltip = am5.Tooltip.new(root, {
      pointerOrientation: "down",
      getFillFromSprite: false,
      getStrokeFromSprite: false,
      autoTextColor: false,
      getLabelFillFromSprite: true,
      labelHTML: `<p style="color:${textColor};" >Open: {openValueY} </br> Low: {lowValueY} </br> High: {highValueY} </br> Close: {valueY}</p><br /> <br />`,
    });
    tooltip.get("background").setAll({
      fill: am5.color(chartColors.panel), // Updated to match theme $firstBox
      fillOpacity: 0.95,
      stroke: am5.color(chartColors.bg), // Updated to match theme $bodyColor
    });
  }

  valueSeries = mainPanel.series.push(
    am5xy.CandlestickSeries.new(root, {
      name: selectedAuthSymbol,
      clustered: false,
      valueXField: 'Date',
      valueYField: 'Close',
      highValueYField: 'High',
      lowValueYField: 'Low',
      openValueYField: 'Open',
      calculateAggregates: true,
      xAxis: dateAxis,
      yAxis: valueAxis,
        tooltip: tooltip,
    }),
  );

    // Set main value series
    stockChart.set('stockSeries', valueSeries);
    // volumeSeries is created below; set again after that so volume indicators work

    // Overlay MA/BB/VWAP legend — same construction as RSI (ChartIndicator).
    // Offset below #chartcontrols (absolute over the plot) so cards are not under
    // the toolbar hit-area and stay as sharp as RSI pane legends.
    let valueLegend = mainPanel.topPlotContainer.children.insertIndex(
      0,
      am5stock.StockLegend.new(root, {
        stockChart: stockChart,
        y: 42,
      }),
    );
    // Keep overlay cards solid/opaque like RSI pane legends (no soft glass look).
    valueLegend.itemContainers.template.setAll({ opacity: 1 });
    valueLegend.itemContainers.template.setup = function (target) {
      target.set('opacity', 1);
      // Replace default background — theme tags alone can leave soft shadow / translucent fill.
      target.set(
        'background',
        am5.RoundedRectangle.new(root, {
          fill: am5.color(chartColors.panel),
          fillOpacity: 1,
          cornerRadiusTL: 4,
          cornerRadiusTR: 4,
          cornerRadiusBL: 4,
          cornerRadiusBR: 4,
          shadowBlur: 0,
          shadowOpacity: 0,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
        }),
      );
    };

    // For Bid Price (lower one)
// let bidBullet = valueSeries.bullets.push(function () {
//   return am5.Bullet.new(root, {
//     locationY: 1, // bottom
//     sprite: am5.Label.new(root, {
//       text: "Bid: 100.50",
//       fill: am5.color(0xffffff),
//       background: am5.Rectangle.new(root, {
//         fill: am5.color(0xff0000),
//       }),
//       centerX: am5.p100,
//       centerY: am5.p100,
//       x: am5.p100, // move to right edge
//       dy: -20 // adjust vertical position
//     })
//   });
// });

// // For Ask Price (above Bid)
// let askBullet = valueSeries.bullets.push(function () {
//   return am5.Bullet.new(root, {
//     locationY: 1,
//     sprite: am5.Label.new(root, {
//       text: "Ask: 100.70",
//       fill: am5.color(0xffffff),
//       background: am5.Rectangle.new(root, {
//         fill: am5.color(0x00ff00),
//       }),
//       centerX: am5.p100,
//       centerY: am5.p100,
//       x: am5.p100,
//       dy: -40 // positioned above Bid
//     })
//   });
// });

// let bidLabel = am5.Label.new(root, {
//   text: `Bid ${406.1}`, // set bidPrice dynamically
//   fontSize: 12,
//   background: am5.RoundedRectangle.new(root, {
//     fill: am5.color(0x00ff00), // green for bid
//     fillOpacity: 0.8,
//   }),
//   fill: am5.color(0x000000),
//   paddingTop: 3,
//   paddingBottom: 3,
//   paddingLeft: 6,
//   paddingRight: 6,
//   x: am5.percent(100),
//   centerX: am5.percent(100),
//   y: valueAxis.valueToPosition(406.1) * stockChart.plotContainer.height() - 20, // position a bit above
//   centerY: am5.p100
// });

// let askLabel = am5.Label.new(root, {
//   text: `Ask ${406.2}`, // set askPrice dynamically
//   fontSize: 12,
//   background: am5.RoundedRectangle.new(root, {
//     fill: am5.color(0xff0000), // red for ask
//     fillOpacity: 0.8,
//   }),
//   fill: am5.color(0x000000),
//   paddingTop: 3,
//   paddingBottom: 3,
//   paddingLeft: 6,
//   paddingRight: 6,
//   x: am5.percent(100),
//   centerX: am5.percent(100),
//   y: valueAxis.valueToPosition(406.2) * stockChart.plotContainer.height(),
//   centerY: am5.p100
// });

// Add to chart
// stockChart.plotContainer.children.push(bidLabel);
// stockChart.plotContainer.children.push(askLabel);


    // Add cursor(s)
    let cursor = mainPanel.set(
      'cursor',
      am5xy.XYCursor.new(root, {
        // behavior: "zoomXY",
        // behavior: "selectXY",
        yAxis: valueAxis,
        xAxis: dateAxis,
        //snapToSeries: [valueSeries],
        //snapToSeriesBy: "y!"
      }),
    );

    cursor.lineX.set("stroke", am5.color(chartColors.muted)); // Updated to match theme $normalTextColor
    cursor.lineY.set("stroke", am5.color(chartColors.muted)); // Updated to match theme $normalTextColor

    cursor.lineX.set("strokeOpacity", 1);
    cursor.lineY.set("strokeOpacity", 1);

    // Regular ticks are not cursor tooltips. Opaque backgrounds on cloned labels
    // can leave a blank rectangle at the clipped end of the date axis.
    [dateAxis, valueAxis].forEach(axis => {
      axis.get('renderer').labels.template.setAll({
        fill: am5.color(chartColors.text),
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 6,
        paddingRight: 6,
      });
      const axisTooltip = axis.get('tooltip');
      axisTooltip.setAll({ getFillFromSprite: false, autoTextColor: false });
      axisTooltip.label.set('fill', am5.color(chartColors.text));
      axisTooltip.get('background').setAll({
        fill: am5.color(chartColors.panel),
        fillOpacity: 1,
        stroke: am5.color(chartColors.muted),
        strokeOpacity: 0.25,
      });
    });

    //#region Zoom Scrollbar Setup------------------------------------------------

    const bgColor = getComputedStyle(document.body).backgroundColor;

    var scrollbarX = am5xy.XYChartScrollbar.new(root, {
      orientation: 'horizontal',
      width: 100,
      x: am5.p100,
      centerX: am5.p100,
      dx: -65,
      y: 30,
      centerY: am5.p100,
      visible: !mobileMode,
    });

    scrollbarX.thumb.setAll({
      fill: am5.color(chartColors.bg), // Updated to match theme $bodyColor
      fillOpacity: 0,
    });

    scrollbarX.startGrip.setAll({
      visible: true,
      scale: 0.6,
    });

    scrollbarX.endGrip.setAll({
      visible: true,
      scale: 0.6,
    });

    scrollbarX.get('background').setAll({
      fill: am5.color(chartColors.panel), // Updated to match theme $firstBox
      fillOpacity: 0,
      cornerRadiusTR: 100,
      cornerRadiusBR: 100,
      cornerRadiusTL: 100,
      cornerRadiusBL: 100,
    });

    // mainPanel.set('scrollbarX', scrollbarX);

    //#endregion

    //#region Create volume axis
    // -------------------------------------------------------------------------------
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    var volumeAxisRenderer = am5xy.AxisRendererY.new(root, {
      inside: true,
    });

    volumeAxisRenderer.labels.template.set('forceHidden', true);
    volumeAxisRenderer.grid.template.set('forceHidden', true);

    var volumeValueAxis = mainPanel.yAxes.push(
      am5xy.ValueAxis.new(root, {
        numberFormat: '#.#a',
        height: am5.percent(20),
        y: am5.percent(100),
        centerY: am5.percent(100),
        renderer: volumeAxisRenderer,
      }),
    );

    //#region Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    volumeSeries = mainPanel.series.push(
      am5xy.ColumnSeries.new(root, {
        name: 'Volume',
        clustered: false,
        valueXField: 'Date',
        valueYField: 'Volume',
        xAxis: dateAxis,
        yAxis: volumeValueAxis,
        legendValueText: "[bold]{valueY.formatNumber('#,###.0a')}[/]",
      }),
    );

    volumeSeries.columns.template.setAll({
      strokeOpacity: 0,
      fillOpacity: 0.2,
    });

    // color columns by stock rules
    volumeSeries.columns.template.adapters.add('fill', function (fill, target) {
      return am5.color(
        getComputedStyle(document.querySelector('.left-nav')).color,
      );
    });
    stockChart.set('volumeSeries', volumeSeries);

    // Set up symbol searchable drop down list
    let symbolSearchList = am5stock.DropdownListControl.new(root, {
      stockChart: stockChart,
      name: selectedAuthSymbol,
      fixedLabel: true,
      searchable: true,
      currentItem: selectedAuthSymbol,
      // items: symbolNames,
      items: symbolNames.map((symbolName) => ({
        id: symbolName,
        label: symbolName,
        className: symbolName === selectedAuthSymbol ? "selected-symbol" : ""
      })),
    });

    // amCharts default search uses innerText + RegExp on every row, which lags on large symbol lists.
    const symbolDropdown = symbolSearchList.getPrivate('dropdown');
    if (symbolDropdown) {
      symbolDropdown._filterItems = function (search) {
        const list = this.getPrivate('list');
        if (!list) return;
        const needle = String(search || '').trim().toLowerCase();
        const items = list.children;
        let visible = 0;
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const text = (
            item.getAttribute('data-am5-title')
            || item.getAttribute('title')
            || item.textContent
            || ''
          ).toLowerCase();
          const show = !needle || text.includes(needle);
          item.style.display = show ? '' : 'none';
          if (show) visible += 1;
        }
        list.classList.toggle('am5stock-list-empty', needle.length > 0 && visible === 0);
      };
    }

    // Function to update dropdown items with current selection
    const updateDropdownItems = (newSelectedSymbol = selectedAuthSymbol) => {
      const updatedItems = symbolNames.map((symbolName) => {
        const isSelected = symbolName === newSelectedSymbol;
        return {
          id: symbolName,
          label: symbolName,
          className: isSelected ? "selected-symbol" : ""
        };
      });
      symbolSearchList.set('items', updatedItems);
      symbolSearchList.set('currentItem', newSelectedSymbol);
    };

    // Add click outside functionality to close dropdown
    const handleClickOutside = (event) => {
      const chartControls = document.getElementById('chartcontrols');
      if (chartControls && !chartControls.contains(event.target)) {
        // Close any open dropdowns
        if (symbolSearchList && symbolSearchList.isOpen && symbolSearchList.isOpen()) {
          symbolSearchList.close();
        }
      }
    };

    // Add event listener for click outside
    document.addEventListener('click', handleClickOutside);
    
    let clickOutsideCleanup = () => {
      document.removeEventListener('click', handleClickOutside);
      eaChartToolbarTeardown();
    };

    symbolSearchList.events.on('selected', function (ev) {
      // An item selected
      const matchingSymbol = symbolWithCategories.find(
        (symbol) => symbol.name === ev.item.label,
      );
      if (matchingSymbol) {
        setSelectedCategoryId(matchingSymbol.symbol_category);
        setAuthSelectedCategory(matchingSymbol.symbol_category);
        setSelectedSymbolSession(matchingSymbol.is_session_active);

        localStorage.setItem('symbol_id', matchingSymbol.id);
        localStorage.setItem('category', matchingSymbol.symbol_category);
      }
      updateSymbolName(ev.item.label);
      setAuthSelectedSymbol(ev.item.label);
      
      // Update dropdown items immediately to show selection
      updateDropdownItems(ev.item.label);
    });

    //#region Series type switcher
    let seriesSwitcher = am5stock.SeriesTypeControl.new(root, {
      stockChart: stockChart,
    });

    seriesSwitcher.events.on('selected', function (ev) {
      newSetSeriesType(ev.item.id);
      setLineCandle(ev.item.id);
    });

    function getNewSettings(series) {
      let newSettings = {};
      am5.array.each(
        [
          'name',
          'valueYField',
          'highValueYField',
          'lowValueYField',
          'openValueYField',
          'calculateAggregates',
          'valueXField',
          'xAxis',
          'yAxis',
          'legendValueText',
          'stroke',
          'fill',
        ],
        function (setting) {
          newSettings[setting] = series.get(setting);
        },
      );
      return newSettings;
    }

    let wheelTimeout;
    mainPanel.events.on('wheelended', function () {
      if (wheelTimeout) {
        wheelTimeout.dispose(); // Clear previous timeout
      }

      wheelTimeout = mainPanel.setTimeout(function () {
        loadChartData(valueSeries, hourglassanimation, indicator, dateAxis, true);
      }, 50);  // Delay slightly to prevent triggering multiple calls
    });

    mainPanel.events.on('panended', function () {
      loadChartData(valueSeries, hourglassanimation, indicator, dateAxis, true);
    });

    function newSetSeriesType(seriesType) {
      // Get current series and its settings
      let currentSeries = stockChart.get('stockSeries');
      let newSettings = getNewSettings(currentSeries);

      // Remove previous series
      let data = currentSeries.data.values;
      mainPanel.series.removeValue(currentSeries);

      // Create new series
      let series;
      switch (seriesType) {
        case 'line': {
          series = mainPanel.series.push(
            am5xy.LineSeries.new(root, newSettings),
          );
          break;
        }
        case 'candlestick': {
          newSettings.clustered = false;
          series = mainPanel.series.push(
            am5xy.CandlestickSeries.new(root, newSettings),
          );
          break;
        }
        case 'procandlestick': {
          newSettings.clustered = false;
          series = mainPanel.series.push(
            am5xy.CandlestickSeries.new(root, newSettings),
          );
          if (seriesType == 'procandlestick') {
            series.columns.template.get('themeTags').push('pro');
          }
          break;
        }
        case 'ohlc': {
          newSettings.clustered = false;
          series = mainPanel.series.push(
            am5xy.OHLCSeries.new(root, newSettings),
          );
          break;
        }
        default: {
          break;
        }
      }

      // Set new series as stockSeries
      if (series) {
        series.data.setAll(data);
        stockChart.set('stockSeries', series);
        let cursor = mainPanel.get('cursor');
        if (cursor) {
          cursor.set('snapToSeries', [series]);
        }
      }
    }

    //set intervals...
    let intervalSwitcher = am5stock.IntervalControl.new(root, {
      stockChart: stockChart,
      currentItem: selectedTimeFrame,
      items: [
        {
          id: '1m',
          label: '1m',
          className: `interval-selected-${selectedTimeFrame === '1m'}`,
          interval: { timeUnit: 'minute', count: 1 },
        },
        {
          id: '5m',
          label: '5m',
          className: `interval-selected-${selectedTimeFrame === '5m'}`,
          interval: { timeUnit: 'minute', count: 5 },
        },
        {
          id: '15m',
          label: '15m',
          className: `interval-selected-${selectedTimeFrame === '15m'}`,
          interval: { timeUnit: 'minute', count: 15 },
        },
        {
          id: '30m',
          label: '30m',
          className: `interval-selected-${selectedTimeFrame === '30m'}`,
          interval: { timeUnit: 'minute', count: 30 },
        },
        {
          id: '1h',
          label: '1h',
          className: `interval-selected-${selectedTimeFrame === '1h'}`,
          interval: { timeUnit: 'hour', count: 1 },
        },
        {
          id: '4h',
          label: '4h',
          className: `interval-selected-${selectedTimeFrame === '4h'}`,
          interval: { timeUnit: 'hour', count: 4 },
        },
        {
          id: '1d',
          label: '1d',
          className: `interval-selected-${selectedTimeFrame === '1d'}`,
          interval: { timeUnit: 'day', count: 1 },
        },
      ],
    });

    intervalSwitcher.events.on('selected', function (ev) {
      updateChartTimeFrame(ev.item.id);
      setAuthTimeFrame(ev.item.id);
      localStorage.setItem('timeFrame', ev.item.id);
    });

    const drawingControl = am5stock.DrawingControl.new(root, {
      stockChart: stockChart,
      scrollable: true,
    });

    let drawingSubtoolbarCollapsed = false;
    let activeDrawingSidebarToolId = '';
    let drawingToolActiveHookBound = false;
    let wasDrawingControlActive = false;
    let drawingOpenAnimTimer = null;
    let scheduleDrawingSidebarSyncRef = () => {};

    const getDrawingSidebarPanel = () => document.querySelector(
      '.am5stock[data-am5-title="Drawing tool"] .am5stock-control-list-container, .am5stock[title="Drawing tool"] .am5stock-control-list-container',
    );

    const applyDrawingSidebarActiveState = (panel) => {
      const list = panel?.querySelector('.am5stock-control-list');
      if (!list) return;

      const tools = drawingControl.getPrivate('toolControl')?.get('tools') || [];
      list.querySelectorAll(
        'li.am5stock-list-item:not(.am5stock-list-heading):not(.am5stock-disabled)',
      ).forEach((item, index) => {
        const toolId = tools[index];
        item.classList.toggle(
          'draw-sidebar-tool-active',
          !!toolId && toolId === activeDrawingSidebarToolId,
        );
      });
    };

    const setDrawingSidebarActiveTool = (toolId, panel = getDrawingSidebarPanel()) => {
      activeDrawingSidebarToolId = toolId || '';
      applyDrawingSidebarActiveState(panel);
    };

    const ensureDrawingToolActiveHook = () => {
      const toolControl = drawingControl.getPrivate('toolControl');
      if (!toolControl || drawingToolActiveHookBound) return;
      drawingToolActiveHookBound = true;

      toolControl.events.on('selected', (ev) => {
        setDrawingSidebarActiveTool(ev.tool || '');
      });
    };

    const ensureDrawingSidebarExpandHook = (panel) => {
      if (!panel || panel.dataset.subtoolbarExpandHookBound) return;
      panel.dataset.subtoolbarExpandHookBound = '1';

      panel.addEventListener('click', (e) => {
        const item = e.target.closest(
          'li.am5stock-list-item:not(.am5stock-list-heading):not(.am5stock-disabled)',
        );
        if (!item) return;

        const list = item.closest('.am5stock-control-list');
        const tools = drawingControl.getPrivate('toolControl')?.get('tools') || [];
        const items = list?.querySelectorAll(
          'li.am5stock-list-item:not(.am5stock-list-heading):not(.am5stock-disabled)',
        );
        if (items) {
          items.forEach((entry, index) => {
            if (entry === item) {
              setDrawingSidebarActiveTool(tools[index] || '', panel);
            }
          });
        }

        if (drawingSubtoolbarCollapsed) {
          setDrawingSubtoolbarCollapsed(false);
        }
      });
    };

    const closeDrawingSubtoolbarDropdowns = () => {
      const drawingTools = document.querySelector('.am5stock-control-drawing-tools');
      if (!drawingTools) return;

      // Deactivate amCharts sub-toolbar controls so dropdown state stays in sync.
      [
        'strokeControl', 'strokeWidthControl', 'strokeDasharrayControl',
        'fillControl', 'iconControl', 'labelFillControl', 'labelFontSizeControl',
        'labelFontFamilyControl',
      ].forEach((key) => {
        const control = drawingControl.getPrivate(key);
        if (control?.get?.('active')) {
          control.set('active', false);
        }
      });

      // Fallback: hide open dropdown panels but keep the drawing sidebar list.
      drawingTools.querySelectorAll(
        ':scope > .am5stock:not([data-am5-title="Drawing tool"]):not([title="Drawing tool"])',
      ).forEach((stock) => {
        stock.classList.remove('am5stock-control-button-active');
        const list = stock.querySelector(':scope > .am5stock-control-list-container');
        if (list) {
          list.style.display = 'none';
        }
      });
    };

    let subtoolbarMotionVersion = 0;
    let subtoolbarAnimations = [];
    const setDrawingSubtoolbarCollapsed = (collapsed) => {
      const el = document.querySelector('.am5stock-control-drawing-tools');
      const chartPane = document.querySelector('.chart-con');
      if (!el) return;
      const version = ++subtoolbarMotionVersion;
      subtoolbarAnimations.forEach(animation => animation.cancel());
      subtoolbarAnimations = [];
      const apply = () => {
        drawingSubtoolbarCollapsed = collapsed;
        el.setAttribute('data-collapsed', collapsed ? 'true' : 'false');
        chartPane?.setAttribute('data-drawing-subtoolbar-collapsed', collapsed ? 'true' : 'false');
        scheduleDrawingSidebarSyncRef();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { apply(); return; }
      const children = [...el.children].filter(child =>
        child.getAttribute('data-am5-title') !== 'Drawing tool' && child.getAttribute('title') !== 'Drawing tool');
      const animate = () => {
        subtoolbarAnimations = children.map((child, index) => child.animate(
          collapsed
            ? [{ opacity: 1, transform: 'translateX(0)' }, { opacity: 0, transform: 'translateX(-24px)' }]
            : [{ opacity: 0, transform: 'translateX(-24px)' }, { opacity: 1, transform: 'translateX(0)' }],
          { duration: 220, delay: collapsed ? 0 : Math.min(index * 18, 100), easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' }
        ));
        Promise.all(subtoolbarAnimations.map(animation => animation.finished)).then(() => {
          if (version !== subtoolbarMotionVersion) return;
          if (collapsed) apply();
          subtoolbarAnimations.forEach(animation => animation.cancel());
          subtoolbarAnimations = [];
        }).catch(() => {});
      };
      if (collapsed) { closeDrawingSubtoolbarDropdowns(); animate(); }
      else {
        const wasCollapsed = drawingSubtoolbarCollapsed;
        apply();
        if (wasCollapsed) {
          // Apply the final fixed position before revealing any toolbar buttons.
          el.style.setProperty('transition', 'none', 'important');
          syncDrawingSidebarLayout();
          if (version === subtoolbarMotionVersion) animate();
        }
      }
    };

    const ensureDrawingSubtoolbarToggle = (drawingTools) => {
      if (!drawingTools) return;

      let toggle = drawingTools.querySelector(':scope > .draw-subtoolbar-toggle');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'draw-subtoolbar-toggle';
        toggle.setAttribute('data-tooltip', 'Collapse tools');
        toggle.setAttribute('aria-label', 'Collapse drawing tools');
        toggle.innerHTML =
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 5.5L8 12l6.5 6.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          setDrawingSubtoolbarCollapsed(true);
        });
      }

      if (drawingTools.lastElementChild !== toggle) {
        drawingTools.appendChild(toggle);
      }

      if (!drawingTools.hasAttribute('data-collapsed')) {
        drawingTools.setAttribute('data-collapsed', drawingSubtoolbarCollapsed ? 'true' : 'false');
      }
    };

    const clearDrawingSubtoolbarLayout = (drawingTools) => {
      if (!drawingTools) return;
      [
        'position', 'top', 'left', 'right', 'width', 'maxWidth', 'height',
        'minHeight', 'maxHeight', 'margin', 'zIndex',
      ].forEach((prop) => drawingTools.style.removeProperty(prop));
    };

    const applyDrawingSubtoolbarLayout = (drawingTools, chartPane, sidebarW, subtoolbarTop, subRowHeight) => {
      if (!drawingTools || getComputedStyle(drawingTools).display === 'none') return;

      // The drawing sidebar dropdown lives inside this container, so it must stay
      // displayed even when collapsed — only its own row is flattened.
      const collapsed = drawingSubtoolbarCollapsed;
      const rowHeight = collapsed ? 0 : subRowHeight;

      drawingTools.setAttribute('data-collapsed', collapsed ? 'true' : 'false');
      drawingTools.style.setProperty('display', 'flex', 'important');
      drawingTools.style.removeProperty('visibility');
      drawingTools.style.removeProperty('pointer-events');
      drawingTools.style.setProperty('position', 'fixed', 'important');
      drawingTools.style.setProperty('top', `${subtoolbarTop}px`, 'important');
      drawingTools.style.setProperty('left', `${sidebarW}px`, 'important');
      drawingTools.style.removeProperty('right');
      drawingTools.style.setProperty('width', collapsed ? '0' : 'max-content', 'important');
      drawingTools.style.setProperty('max-width', `calc(100% - ${sidebarW}px)`, 'important');
      drawingTools.style.setProperty('height', `${rowHeight}px`, 'important');
      drawingTools.style.setProperty('min-height', `${rowHeight}px`, 'important');
      drawingTools.style.setProperty('max-height', `${rowHeight}px`, 'important');
      drawingTools.style.setProperty('margin', '0', 'important');
      drawingTools.style.setProperty('margin-top', '0', 'important');
      drawingTools.style.setProperty('padding-top', '0', 'important');
      drawingTools.style.setProperty('border-top', 'none', 'important');
      drawingTools.style.setProperty('transform', 'none', 'important');
      drawingTools.style.setProperty('z-index', '50', 'important');
    };

    const closeAllDrawPanels = (finish = false) => {
      const pane = document.querySelector('.chart-con');
      if (finish !== true && pane?.getAttribute('data-drawing-open') === 'true' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (pane.getAttribute('data-drawing-anim') === 'close') return;
        if (drawingOpenAnimTimer) window.clearTimeout(drawingOpenAnimTimer);
        pane.setAttribute('data-drawing-anim', 'close');
        drawingOpenAnimTimer = window.setTimeout(() => {
          drawingOpenAnimTimer = null;
          closeAllDrawPanels(true);
        }, 460);
        return;
      }
      if (drawingOpenAnimTimer) {
        window.clearTimeout(drawingOpenAnimTimer);
        drawingOpenAnimTimer = null;
      }
      document.querySelector('.chart-con')?.removeAttribute('data-drawing-anim');

      drawingControl.getPrivate('toolControl')?.set('active', false);
      if (drawingControl.get('active')) {
        drawingControl.set('active', false);
      }
      document
        .querySelectorAll('.am5stock-control-drawing-tools .am5stock-control-list-container')
        .forEach((el) => {
          el.style.display = 'none';
        });
      document.querySelector('.chart-con')?.setAttribute('data-drawing-open', 'false');
      document.querySelector('.chart-con')?.setAttribute('data-drawing-toolbar', 'false');
      document.querySelector('.chart-con')?.setAttribute('data-drawing-subtoolbar-collapsed', 'false');
      document.getElementById('chartcontrols')?.style.removeProperty('padding-left');
      clearDrawingSubtoolbarLayout(document.querySelector('.am5stock-control-drawing-tools'));
      drawingSubtoolbarCollapsed = false;
      activeDrawingSidebarToolId = '';
      document.querySelectorAll('.draw-sidebar-tool-active').forEach((el) => {
        el.classList.remove('draw-sidebar-tool-active');
      });
      document.querySelector('.chart-con')?.closest('.chart-box')?.setAttribute('data-drawing-sidebar-open', 'false');
      document.querySelector('.chart-con')?.style.removeProperty('--draw-sidebar-width');
      document.querySelector('.chart-con')?.style.removeProperty('--draw-close-height');
      document.querySelector('.chart-con')?.style.removeProperty('--draw-subtoolbar-top');
      wasDrawingControlActive = false;
    };

    // Stock toolbar
    am5stock.StockToolbar.new(root, {
      container: document.getElementById('chartcontrols'),
      stockChart: stockChart,
      controls: [
        symbolSearchList,
        seriesSwitcher,
        intervalSwitcher,
        am5stock.IndicatorControl.new(root, {
          stockChart: stockChart,
          legend: valueLegend,
          searchable: true,
          maxSearchItems: 1000,
          searchCallback: function (query) {
            const needle = String(query || '').trim().toLowerCase();
            const items = this.get('items') || [];
            if (!needle) return items;
            return items.filter((item) => {
              const label = (item.label || item.id || '').toString().toLowerCase();
              return label.includes(needle);
            });
          },
        }),
        drawingControl,
        am5stock.SettingsControl.new(root, {
          stockChart: stockChart,
          autoSave: true,
          exclude: ["y-scale"]
        }),
        am5stock.ResetControl.new(root, {
          stockChart: stockChart,
        }),
      ],
    });

    // Harden every StockLegend (overlay + panel indicators like RSI) so cards stay solid.
    const hardenStockLegend = (legend) => {
      if (!legend || !legend.itemContainers) return;
      legend.itemContainers.template.setAll({ opacity: 1 });
      legend.itemContainers.template.setup = function (target) {
        target.set('opacity', 1);
        target.set(
          'background',
          am5.RoundedRectangle.new(root, {
            fill: am5.color(chartColors.panel),
            fillOpacity: 1,
            cornerRadiusTL: 4,
            cornerRadiusTR: 4,
            cornerRadiusBL: 4,
            cornerRadiusBR: 4,
            shadowBlur: 0,
            shadowOpacity: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
          }),
        );
      };
    };
    hardenStockLegend(valueLegend);
    stockChart.indicators.events.on('push', () => {
      requestAnimationFrame(() => {
        stockChart.panels.each((panel) => {
          ['topPlotContainer', 'plotContainer'].forEach((key) => {
            const box = panel[key];
            if (!box || !box.children) return;
            box.children.each((ch) => {
              if (String(ch.className || '').includes('StockLegend')) hardenStockLegend(ch);
            });
          });
        });
      });
    });

    requestAnimationFrame(() => eaChartToolbarReady());

    const searchableDropdownSelector =
      '#chartcontrols .am5stock:nth-child(1) .am5stock-control-list-container, #chartcontrols .am5stock:nth-child(4) .am5stock-control-list-container';

    const syncSearchDropdownWidths = () => {
      document.querySelectorAll(searchableDropdownSelector).forEach((container) => {
        const visible = container.offsetWidth > 0
          && getComputedStyle(container).display !== 'none';
        if (!visible) {
          delete container.dataset.widthLocked;
          container.style.width = '';
          container.style.minWidth = '';
          container.style.maxWidth = '';
          return;
        }
        if (container.dataset.widthLocked) return;
        const w = container.offsetWidth;
        if (w < 1) return;
        container.style.boxSizing = 'border-box';
        container.style.width = `${w}px`;
        container.style.minWidth = `${w}px`;
        container.style.maxWidth = `${w}px`;
        container.dataset.widthLocked = '1';
      });
    };

    const chartControlsEl = document.getElementById('chartcontrols');
    let dropdownWidthRaf = 0;
    const scheduleDropdownWidthSync = () => {
      cancelAnimationFrame(dropdownWidthRaf);
      dropdownWidthRaf = requestAnimationFrame(() => {
        dropdownWidthRaf = requestAnimationFrame(syncSearchDropdownWidths);
      });
    };

    chartControlsEl?.addEventListener('click', scheduleDropdownWidthSync);
    chartControlsEl?.addEventListener('input', scheduleDropdownWidthSync, true);
    chartControlsEl?.addEventListener('focusin', scheduleDropdownWidthSync, true);

    const dropdownWidthObserver = new MutationObserver(scheduleDropdownWidthSync);
    if (chartControlsEl) {
      dropdownWidthObserver.observe(chartControlsEl, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    }

    // Enhance indicator modal selects with UI dropdown clone
    const enhanceModalSelects = () => {
      const modals = document.querySelectorAll('.am5-modal-wrapper .am5-modal-table');
      modals.forEach((table) => {
        const selects = table.querySelectorAll('select.am5-modal-input, select');
        selects.forEach((select) => {
          if (select.dataset.customEnhanced === 'true') return;
          select.dataset.customEnhanced = 'true';
          select.style.display = 'none';

          const wrapper = document.createElement('div');
          wrapper.className = 'am5-custom-select';

          const control = document.createElement('div');
          control.className = 'am5-custom-select-control';
          control.tabIndex = 0;

          const currentOption = select.options[select.selectedIndex] || select.options[0];
          const valueSpan = document.createElement('span');
          valueSpan.className = 'am5-custom-select-value';
          valueSpan.textContent = currentOption ? currentOption.text : '';

          const indicator = document.createElement('div');
          indicator.className = 'am5-custom-select-indicator';
          indicator.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';

          control.appendChild(valueSpan);
          control.appendChild(indicator);

          const menu = document.createElement('div');
          menu.className = 'am5-custom-select-menu';

          const updateOptions = () => {
            menu.innerHTML = '';
            Array.from(select.options).forEach((opt) => {
              const item = document.createElement('div');
              item.className = 'am5-custom-select-option' + (opt.selected ? ' is-selected' : '');
              item.textContent = opt.text;
              item.dataset.value = opt.value;

              item.addEventListener('click', (e) => {
                e.stopPropagation();
                select.value = opt.value;
                valueSpan.textContent = opt.text;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                select.dispatchEvent(new Event('input', { bubbles: true }));
                wrapper.classList.remove('is-open');
                updateOptions();
              });

              menu.appendChild(item);
            });
          };

          updateOptions();

          control.addEventListener('click', (e) => {
            e.stopPropagation();
            const isOpen = wrapper.classList.contains('is-open');
            document.querySelectorAll('.am5-custom-select.is-open').forEach((w) => {
              w.classList.remove('is-open', 'open-up');
              const m = w.querySelector('.am5-custom-select-menu');
              if (m) {
                m.style.removeProperty('max-height');
                m.style.removeProperty('overflow-y');
              }
            });
            if (!isOpen) {
              const rect = control.getBoundingClientRect();
              const fullMenuHeight = (select.options.length || 5) * 24 + 4;

              // Constrain strictly within visible chart container (avoids hiding behind bottom positions bar)
              const chartEl = document.getElementById('chartdiv') || control.closest('.chart-container') || control.closest('.am5-modal-wrapper')?.parentElement || document.body;
              const chartRect = chartEl.getBoundingClientRect();

              const visibleTop = Math.max(0, chartRect.top) + 20; // safe buffer below top bar
              const visibleBottom = Math.min(window.innerHeight, chartRect.bottom) - 10; // safe buffer above bottom panel

              const spaceBelow = Math.max(0, visibleBottom - rect.bottom);
              const spaceAbove = Math.max(0, rect.top - visibleTop);

              let openUp = false;
              let availableSpace = spaceBelow;

              if (spaceBelow >= fullMenuHeight) {
                openUp = false;
                availableSpace = spaceBelow;
              } else if (spaceAbove >= fullMenuHeight) {
                openUp = true;
                availableSpace = spaceAbove;
              } else {
                // Pick whichever side has more room
                if (spaceBelow >= spaceAbove) {
                  openUp = false;
                  availableSpace = spaceBelow;
                } else {
                  openUp = true;
                  availableSpace = spaceAbove;
                }
              }

              if (openUp) {
                wrapper.classList.add('open-up');
              } else {
                wrapper.classList.remove('open-up');
              }

              const maxAllowed = Math.min(fullMenuHeight, Math.max(availableSpace, 60));
              menu.style.setProperty('max-height', maxAllowed + 'px', 'important');
              menu.style.setProperty('overflow-y', 'auto', 'important');
              menu.style.setProperty('overflow-x', 'hidden', 'important');

              wrapper.classList.add('is-open');
            }
          });

          wrapper.appendChild(control);
          wrapper.appendChild(menu);

          select.parentNode.insertBefore(wrapper, select.nextSibling);
        });

        // Column alignment: when a modal has rows with both inputs and color controls,
        // align all inputs into the left column and colors into the right column
        const rows = table.querySelectorAll('.am5-modal-table-row');
        let hasMixedRow = false;
        rows.forEach((row) => {
          const hasColor = row.querySelector('.am5stock-control-color, .am5stock-control-icon');
          const hasInput = row.querySelector('input, select, .am5-custom-select');
          if (hasInput && hasColor) {
            hasMixedRow = true;
          }
        });

        if (hasMixedRow) {
          table.classList.add('am5-modal-has-color-col');
          rows.forEach((row) => {
            const hasColor = row.querySelector('.am5stock-control-color, .am5stock-control-icon');
            const cells = row.querySelectorAll('.am5-modal-table-cell');
            cells.forEach((cell) => {
              if (cell.querySelector('.am5stock-control-color, .am5stock-control-icon')) {
                cell.classList.add('am5-cell-color');
                cell.style.removeProperty('margin-right');
              } else if (!hasColor) {
                cell.classList.add('am5-cell-no-color');
                cell.style.setProperty('margin-right', '32px', 'important');
              } else {
                cell.classList.remove('am5-cell-no-color');
                cell.style.removeProperty('margin-right');
              }
            });
          });
        } else {
          table.classList.remove('am5-modal-has-color-col');
          rows.forEach((row) => {
            const cells = row.querySelectorAll('.am5-modal-table-cell');
            cells.forEach((cell) => {
              cell.classList.remove('am5-cell-no-color');
              cell.style.removeProperty('margin-right');
              if (cell.querySelector('.am5stock-control-color, .am5stock-control-icon')) {
                cell.classList.add('am5-cell-color');
              }
            });
          });
        }

        // Multi-column layout only when modal content does not fit the screen or has many rows
        const modalContent = table.closest('.am5-modal-content');
        if (modalContent) {
          const availHeight = window.innerHeight - 90;
          const isOverflowing = rows.length > 5 || (modalContent.offsetHeight > availHeight);
          if (isOverflowing) {
            modalContent.classList.add('am5-modal-wide');
          } else {
            modalContent.classList.remove('am5-modal-wide');
          }
        }
      });
    };

    document.addEventListener('click', () => {
      document.querySelectorAll('.am5-custom-select.is-open').forEach((w) => {
        w.classList.remove('is-open', 'open-up');
        const m = w.querySelector('.am5-custom-select-menu');
        if (m) {
          m.style.removeProperty('max-height');
          m.style.removeProperty('overflow-y');
        }
      });
    });

    const modalObserver = new MutationObserver(enhanceModalSelects);
    modalObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const ensureDrawPanelClose = (panel) => {
      if (panel.querySelector('.draw-panel-close')) return;

      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'draw-panel-close';
      closeBtn.setAttribute('aria-label', 'Close drawing panel');
      closeBtn.setAttribute('data-tooltip', 'Close');
      closeBtn.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" fill="none"/></svg>';
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeAllDrawPanels();
      });
      panel.insertBefore(closeBtn, panel.firstChild);
    };

    const measureAxisBandHeight = (chartPaneEl, chartdivEl) => {
      const fallback = parseFloat(
        getComputedStyle(chartPaneEl).getPropertyValue('--chart-axis-reserve'),
      ) || 40;

      if (!chartdivEl) return fallback;

      const divRect = chartdivEl.getBoundingClientRect();
      let axisTop = divRect.bottom;

      chartdivEl.querySelectorAll('text').forEach((node) => {
        const rect = node.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        if (rect.bottom <= divRect.top + divRect.height * 0.72) return;
        if (rect.top < axisTop) axisTop = rect.top;
      });

      if (axisTop < divRect.bottom - 1) {
        return Math.max(fallback, Math.ceil(divRect.bottom - axisTop + 4));
      }

      return fallback;
    };

    const ensureDrawPanelAxisMask = (panel, bandHeight) => {
      let mask = panel.querySelector('.draw-panel-axis-mask');
      if (!mask) {
        mask = document.createElement('div');
        mask.className = 'draw-panel-axis-mask';
        mask.setAttribute('aria-hidden', 'true');
      }
      mask.style.height = `${bandHeight}px`;
      if (mask.parentElement !== panel) {
        panel.insertBefore(mask, panel.firstChild);
      } else if (panel.firstChild !== mask) {
        panel.insertBefore(mask, panel.firstChild);
      }
    };

    const measureDrawingLayoutMetrics = (chartPaneEl, chartControlsEl) => {
      const rowFallback = parseFloat(
        getComputedStyle(chartPaneEl).getPropertyValue('--chart-toolbar-row-height'),
      ) || 37;

      if (!chartPaneEl || !chartControlsEl) {
        return { closeHeight: rowFallback, subtoolbarTop: rowFallback, subRowHeight: rowFallback };
      }

      const paneRect = chartPaneEl.getBoundingClientRect();
      let iconBottom = 0;

      chartControlsEl.querySelectorAll(':scope > .am5stock, :scope > #ea-chart-control').forEach((el) => {
        const style = getComputedStyle(el);
        if (style.display === 'none') return;
        const rect = el.getBoundingClientRect();
        if (rect.height < 1) return;
        iconBottom = Math.max(iconBottom, rect.bottom - paneRect.top);
      });

      if (iconBottom < 1) {
        iconBottom = chartControlsEl.getBoundingClientRect().bottom - paneRect.top;
      }

      // Theme padding leaves dead space under the icon row; pull the sub-toolbar
      // back up so it sits flush against the main toolbar.
      const toolbarBand = Math.max(24, Math.ceil(iconBottom) - DRAW_SUBTOOLBAR_NUDGE);
      return {
        closeHeight: toolbarBand,
        subtoolbarTop: toolbarBand,
        subRowHeight: rowFallback,
      };
    };

    const syncDrawingSidebarLayout = () => {
      const chartPane = document.querySelector('.chart-con');
      const chartControls = document.getElementById('chartcontrols');
      const chartdiv = document.getElementById('chartdiv');
      const drawingTools = document.querySelector('.am5stock-control-drawing-tools');
      const panel = document.querySelector(
        '.am5stock[data-am5-title="Drawing tool"] .am5stock-control-list-container, .am5stock[title="Drawing tool"] .am5stock-control-list-container',
      );

      const panelOpen = !!panel
        && getComputedStyle(panel).display !== 'none'
        && panel.offsetWidth > 0;

      const drawingToolsAmOpen = !!drawingTools
        && (drawingControl.get('active') || getComputedStyle(drawingTools).display !== 'none');

      if (!panelOpen && !drawingToolsAmOpen) {
        chartControls?.style.removeProperty('padding-left');
        clearDrawingSubtoolbarLayout(drawingTools);
        chartPane?.setAttribute('data-drawing-open', 'false');
        chartPane?.setAttribute('data-drawing-toolbar', 'false');
        chartPane?.closest('.chart-box')?.setAttribute('data-drawing-sidebar-open', 'false');
        chartPane?.style.removeProperty('--chart-axis-band');
        chartPane?.style.removeProperty('--draw-sidebar-width');
        chartPane?.style.removeProperty('--draw-close-height');
        chartPane?.style.removeProperty('--draw-subtoolbar-top');
        return;
      }

      const sidebarW = panelOpen
        ? (panel.offsetWidth || 44)
        : (drawingToolsAmOpen ? 44 : 0);

      chartPane?.setAttribute('data-drawing-open', panelOpen ? 'true' : 'false');
      chartPane?.setAttribute('data-drawing-toolbar', drawingToolsAmOpen ? 'true' : 'false');
      chartPane?.setAttribute(
        'data-drawing-subtoolbar-collapsed',
        drawingSubtoolbarCollapsed ? 'true' : 'false',
      );
      chartPane?.closest('.chart-box')?.setAttribute(
        'data-drawing-sidebar-open',
        panelOpen ? 'true' : 'false',
      );
      chartPane?.style.setProperty('--draw-sidebar-width', `${sidebarW}px`);

      if (sidebarW > 0) {
        chartControls.style.setProperty('padding-left', `${sidebarW + 4}px`, 'important');
      } else {
        chartControls?.style.removeProperty('padding-left');
      }

      // Let drawing-mode CSS (padding-bottom: 0) apply before measuring icon row.
      void chartControls.offsetHeight;

      const { closeHeight, subtoolbarTop, subRowHeight } = measureDrawingLayoutMetrics(
        chartPane,
        chartControls,
      );
      chartPane?.style.setProperty('--draw-close-height', `${closeHeight}px`);
      chartPane?.style.setProperty('--draw-subtoolbar-top', `${subtoolbarTop}px`);

      if (drawingToolsAmOpen) {
        ensureDrawingSubtoolbarToggle(drawingTools);
        applyDrawingSubtoolbarLayout(
          drawingTools,
          chartPane,
          sidebarW || 44,
          subtoolbarTop,
          subRowHeight,
        );
      } else {
        clearDrawingSubtoolbarLayout(drawingTools);
      }

      if (!panelOpen) return;

      ensureDrawingToolActiveHook();
      ensureDrawingSidebarExpandHook(panel);

      ensureDrawPanelClose(panel);

      panel.style.top = '0';
      panel.style.left = '0';
      panel.style.margin = '0';
      panel.style.padding = '0';
      panel.style.borderRadius = '0';
      panel.style.borderBottomLeftRadius = '0';
      panel.style.borderBottomRightRadius = '0';

      const axisBandHeight = measureAxisBandHeight(chartPane, chartdiv);

      // Stretch the sidebar down to the Positions/tabs rail so there is no gap
      // under the chart (resize strip) before the bottom panel.
      const accountPanel = chartPane?.closest('.direction-col')?.querySelector('.bottom-section');
      const bottomRail = accountPanel?.querySelector('.tabs-section-acc') ?? accountPanel;
      const accountHidden = accountPanel?.getAttribute('aria-hidden') === 'true';
      const tabsTop = accountHidden
        ? Math.min(window.innerHeight, chartPane.closest('.direction-col').getBoundingClientRect().bottom)
        : bottomRail?.getBoundingClientRect().top;
      const chartBottom = chartdiv?.getBoundingClientRect().bottom
        ?? chartPane?.getBoundingClientRect().bottom
        ?? window.innerHeight;

      panel.style.removeProperty('max-height');
      panel.style.overflow = 'hidden';
      if (Number.isFinite(tabsTop) && tabsTop > 0) {
        // Fixed positioning is relative to the transformed chart pane.
        const panelTop = panel.getBoundingClientRect().top;
        panel.style.setProperty('bottom', 'auto', 'important');
        panel.style.setProperty('height', `${Math.max(0, tabsTop - panelTop)}px`, 'important');
      } else {
        panel.style.removeProperty('height');
        panel.style.bottom = '0';
      }
      chartPane?.style.setProperty('--chart-axis-band', `${axisBandHeight}px`);
      ensureDrawPanelAxisMask(panel, axisBandHeight);

      // Keep the axis mask on the chart time-axis, not at the new panel foot.
      const mask = panel.querySelector('.draw-panel-axis-mask');
      if (mask && Number.isFinite(tabsTop) && tabsTop > 0) {
        const offsetFromPanelBottom = Math.max(0, Math.round(tabsTop - chartBottom));
        mask.style.bottom = `${offsetFromPanelBottom}px`;
        mask.style.height = `${axisBandHeight}px`;
      }

      const list = panel.querySelector('.am5stock-control-list');
      if (!list) return;

      list.style.removeProperty('max-height');
      list.style.removeProperty('height');
      list.style.display = 'flex';
      list.style.flexDirection = 'column';
      list.style.removeProperty('padding-top');
      list.style.removeProperty('padding-bottom');

      const items = list.querySelectorAll(
        'li.am5stock-list-item:not(.am5stock-list-heading):not(.am5stock-disabled)',
      );
      if (!items.length) return;

      const gap = DRAW_SIDEBAR_GAP;
      const sampleH = items[0].getBoundingClientRect().height || 24;
      let contentH = 0;
      items.forEach((item) => {
        contentH += item.getBoundingClientRect().height || sampleH;
      });

      const listStyles = getComputedStyle(list);
      const padTop = parseFloat(listStyles.paddingTop) || 0;
      const padBottom = parseFloat(listStyles.paddingBottom) || 0;
      const available = list.clientHeight - padTop - padBottom;

      list.style.gap = `${gap}px`;
      list.style.removeProperty('overflow-y');

      const totalH = contentH + gap * Math.max(0, items.length - 1);
      list.classList.toggle('is-scrollable', totalH > available);

      if (!activeDrawingSidebarToolId && drawingControl.get('tool')) {
        activeDrawingSidebarToolId = drawingControl.get('tool');
      }

      applyDrawingSidebarActiveState(panel);
    };

    const scheduleDrawingSidebarSync = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(syncDrawingSidebarLayout);
      });
    };
    scheduleDrawingSidebarSyncRef = scheduleDrawingSidebarSync;

    // Opening the draw control always starts with both panels expanded.
    drawingControl.on('active', (active) => {
      const chartPane = document.querySelector('.chart-con');
      const shouldAnimateOpen = active && !wasDrawingControlActive;
      wasDrawingControlActive = active;

      if (drawingOpenAnimTimer) {
        window.clearTimeout(drawingOpenAnimTimer);
        drawingOpenAnimTimer = null;
      }

      if (!active) {
        chartPane?.removeAttribute('data-drawing-anim');
        scheduleDrawingSidebarSync();
        return;
      }

      drawingSubtoolbarCollapsed = false;
      document
        .querySelector('.am5stock-control-drawing-tools')
        ?.setAttribute('data-collapsed', 'false');
      chartPane?.setAttribute('data-drawing-subtoolbar-collapsed', 'false');

      drawingControl.getPrivate('toolControl')?.set('active', true);

      if (shouldAnimateOpen) {
        // One flag for the whole intro: CSS staggers the sidebar slide-in first and
        // the sub-toolbar reveal after it, so the phases can't fight each other.
        chartPane?.setAttribute('data-drawing-anim', 'open');
        scheduleDrawingSidebarSync();

        drawingOpenAnimTimer = window.setTimeout(() => {
          chartPane?.removeAttribute('data-drawing-anim');
          drawingOpenAnimTimer = null;
          scheduleDrawingSidebarSync();
        }, 700);
        return;
      }

      chartPane?.removeAttribute('data-drawing-anim');
      scheduleDrawingSidebarSync();
    });

    const closeDrawingFromToolbar = event => {
      const trigger = event.target?.closest?.('.am5stock[data-am5-title="Drawing tool"], .am5stock[title="Drawing tool"]');
      if (!trigger || event.target.closest('.am5stock-control-list-container')) return;
      if (!drawingControl.get('active')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      closeAllDrawPanels();
    };
    chartControlsEl?.addEventListener('click', closeDrawingFromToolbar, true);
    chartControlsEl?.addEventListener('click', scheduleDrawingSidebarSync);

    const drawingSidebarObserver = new MutationObserver(scheduleDrawingSidebarSync);
    if (chartControlsEl) {
      drawingSidebarObserver.observe(chartControlsEl, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    }

    const chartPane = document.querySelector('.chart-con');
    const chartPaneResizeObserver = chartPane
      ? new ResizeObserver(scheduleDrawingSidebarSync)
      : null;
    chartPaneResizeObserver?.observe(chartPane);

    const chartBox = document.querySelector('.chart-box');
    const chartBoxResizeObserver = chartBox
      ? new ResizeObserver(scheduleDrawingSidebarSync)
      : null;
    chartBoxResizeObserver?.observe(chartBox);

    let lastAxisLayoutSync = 0;
    const frameEndedDisposer = root.events.on('frameended', () => {
      if (!document.querySelector('.chart-con[data-drawing-open="true"]')
        && !document.querySelector('.chart-con[data-drawing-toolbar="true"]')) return;
      const now = Date.now();
      if (now - lastAxisLayoutSync < 250) return;
      lastAxisLayoutSync = now;
      scheduleDrawingSidebarSync();
    });
    scheduleDrawingSidebarSync();

    const prevCleanup = clickOutsideCleanup;
    clickOutsideCleanup = () => {
      prevCleanup();
      chartControlsEl?.removeEventListener('click', scheduleDropdownWidthSync);
      chartControlsEl?.removeEventListener('input', scheduleDropdownWidthSync, true);
      chartControlsEl?.removeEventListener('focusin', scheduleDropdownWidthSync, true);
      chartControlsEl?.removeEventListener('click', closeDrawingFromToolbar, true);
      chartControlsEl?.removeEventListener('click', scheduleDrawingSidebarSync);
      cancelAnimationFrame(dropdownWidthRaf);
      dropdownWidthObserver.disconnect();
      drawingSidebarObserver.disconnect();
      chartPaneResizeObserver?.disconnect();
      chartBoxResizeObserver?.disconnect();
      frameEndedDisposer.dispose();
    };

    //#region Load initial data
    try {
      loadChartData(valueSeries, hourglassanimation, indicator);
    } catch (error) {
      console.error('Error loading chart data:', error);
      console.log(error);
    }
  //   if (savedClickedPosition) {
  //     createChartBulletClosePosition(savedClickedPosition);
  // }

    chartRef.current = stockChart;
    valueSeriesRef.current = valueSeries;
    setChartInitialized(true);
    
    // Return cleanup function
    return clickOutsideCleanup;
  };

  const loadChartData = (series, hourglassanimation, indicator, dateAxis, isPanEnded = false) => {
    if (isPanEnded) {

      if (dateAxis._settings.start <= 0.01) {
        if (allChartDataRef.current.length > currentChartDataRef.current.length) {
          // Calculate how many more candles to load
          const remainingCandles = allChartDataRef.current.length - currentChartDataRef.current.length;
          const candlesToLoad = Math.min(remainingCandles, candleLength);

          const additionalCandles = allChartDataRef.current
            .slice(
              Math.max(0, allChartDataRef.current.length - currentChartDataRef.current.length - candlesToLoad),
              allChartDataRef.current.length - currentChartDataRef.current.length
            )
            // .filter(candle => candle.Date < currentChartData[0]?.Date); // Avoid duplicates
            ;

          let currChartData2 = additionalCandles.concat(currentChartDataRef.current);
          //Updating reference
          currentChartDataRef.current = currChartData2

          // Update the chart series
          series.data.setAll(currChartData2);
          window.dispatchEvent(new CustomEvent('symbol-chart-ready', { detail: { symbol: selectedAuthSymbol } }));

          createChartBullets(series);
        }
      }

    } else {
      // If we don't have more data, call the API
      am5.net
        .load(
          API_ENDPOINT_KLINES_MT(
            selectedAuthSymbol,
            selectedTimeFrame,
            user?.userId,
            localStorage.getItem('symbol_id')
              ? localStorage.getItem('symbol_id')
              : selectedAuthSymbolId,
            localStorage.getItem('category')
              ? localStorage.getItem('category')
              : defaultSelectedCategory,
          ),
          series,
        )
        .then(function (result) {
          const res = am5.JSONParser.parse(result.response);
          const chartData = res.data.map((item) => {
            return {
              Date: new Date(item.time).getTime(),
              RealDate: new Date(item.time),
              Open: parseFloat(item.open),
              High: parseFloat(item.high),
              Low: parseFloat(item.low),
              Close: parseFloat(item.close),
              Volume: parseFloat(item.volume),
            };
          });


          // allChartData = chartData;
          allChartDataRef.current = chartData

          let currChartData = chartData.slice(
            Math.max(0, chartData.length - candleLength),
            chartData.length
          );

          currentChartDataRef.current = currChartData

          // Set Series data
          result.target.data.setAll(currChartData);
          window.dispatchEvent(new CustomEvent('symbol-chart-ready', { detail: { symbol: selectedAuthSymbol } }));
          // series.data.setAll(currentChartData);
          hourglassanimation.pause();
          indicator.hide();
          // dataReady = true;
          setDataReady(true);
          setIsReconnected(false);

        })
        .catch((err) => {
          console.warn('[Chart] klines load failed:', err?.message || err);
          hourglassanimation?.pause?.();
          indicator?.hide?.();
        });
    }
  };

  let greenBullets = [];
  let greenBullets2 = [];

  const createChartBullets = () => {
    const valueSeries = valueSeriesRef.current;
  
    if (!valueSeries) {
      // console.error("valueSeriesRef is not initialized");
      return;
    }
  
    // Dispose of existing bullets
    greenBullets.forEach((bullet) => bullet.dispose());
    greenBullets = []; // Reset bullets array
  
    if (showBullets) {
        // console.log("Creating bullets for open positions");
  
      const timeFrameInMinutes = {
        '1m': 1,
        '5m': 5,
        '15m': 15,
        '30m': 30,
        '1h': 60,
        '4h': 240,
        '1d': 1440,
      };
  
      const timeframe = timeFrameInMinutes[selectedTimeFrame] || 1;
  
        // Map positions by normalized time
      const bulletMap = new Map();
  
      const allPositions = [...openPositions, ...closedPositionsAll];
  
      allPositions
        .filter((position) => position.symbol === selectedAuthSymbol)
        .forEach((position) => {
          const positionTime = new Date(position.position_opened_at || position.created_at).getTime();
  
          if (isNaN(positionTime)) {
            console.warn("Skipping position due to invalid time:", position);
            return;
          }
  
          const normalizedTime = Math.floor(positionTime / (timeframe * 60 * 1000)) * (timeframe * 60 * 1000);
  
                // Create separate entries for Buy and Sell positions at the same time
          const key = `${normalizedTime}-${position.direction}`;
          if (!bulletMap.has(key)) {
            bulletMap.set(key, []);
          }
  
          bulletMap.get(key).push(position);
        });
  
        // Create bullets for each group (Buy/Sell separately)
      bulletMap.forEach((positions, key) => {
        valueSeries.bullets.push(function (root, series, dataItem) {
          const candleStartTime = new Date(dataItem.dataContext.Date).getTime();
          const [timestamp, direction] = key.split('-');
  
          if (parseInt(timestamp) === candleStartTime) {
            const bulletsForTimestamp = [];
  
            const activePositions = positions.filter(
              (p) => !closedPositionsAll.find((c) => c.position_id === p.position_id)
            );
            const closedPositions = positions.filter((p) =>
              closedPositionsAll.find((c) => c.position_id === p.position_id)
            );
  
            positions.forEach((position, index) => {
              const isBuy = position.direction === "Buy";
              const svgPath = isBuy
                ? "M0,10 L5,0 L10,10 Z" // Upward arrow
                : "M0,0 L5,10 L10,0 Z"; // Downward arrow
  
              const dy = isBuy ? (index + 1) * 20 : -(index + 1) * 20;
  
              const tooltipHTML = `
                Open: ${
                  activePositions.length > 0
                    ? activePositions.map((p) => `<div>${p.position_id}</div>`).join("")
                    : "None"
                }
                Closed: ${
                  closedPositions.length > 0
                    ? closedPositions.map((p) => `<div>${p.position_id}</div>`).join("")
                    : "None"
                }</br>
                ${activePositions.length === 0 ? "<strong>All positions closed</strong>" : ""}
              `;
  
              const arrow = am5.Graphics.new(root, {
                svgPath,
                fill: isBuy ? am5.color(selectedStyle.buyColor) : am5.color(selectedStyle.sellColor),
                stroke: am5.color(chartColors.text), // Updated to match theme $boldTextColor
                strokeWidth: 1,
                centerY: am5.p50,
                centerX: am5.p50,
                dy,
                tooltipHTML: tooltipHTML,
              });
  
              const bullet = am5.Bullet.new(root, {
                field: isBuy ? "high" : "low",
                sprite: arrow,
              });
  
              bulletsForTimestamp.push(bullet);
            });
  
            greenBullets.push(...bulletsForTimestamp);
            return bulletsForTimestamp[0];
          }
        });
      });
    } else {
      greenBullets.forEach((bullet) => bullet.dispose());
      greenBullets = [];
    }
  };
  

// Hook to watch for closed positions and remove bullets
useEffect(() => {
    closedPositionsAll.forEach((closedPosition) => {
        const bulletIndex = greenBullets.findIndex(
            (bullet) => bullet.positionId === closedPosition.position_id
        );

        if (bulletIndex !== -1) {
            // Dispose the bullet
            greenBullets[bulletIndex].dispose();
            // Remove from the array
            greenBullets.splice(bulletIndex, 1);
        }
    });
}, [closedPositionsAll]);



const createChartBullets2 = () => {
  const valueSeries = valueSeriesRef.current;

  if (!valueSeries) {
    // console.error("valueSeriesRef is not initialized");
    return;
  }

  // Dispose existing bullets
  greenBullets2.forEach((bullet) => bullet.dispose());
  greenBullets2 = []; // Reset bullets array

  if (showBullets) {
    console.log("Creating bullets for closed positions");

    const timeFrameInMinutes = {
      '1m': 1,
      '5m': 5,
      '15m': 15,
      '30m': 30,
      '1h': 60,
      '4h': 240,
      '1d': 1440,
    };

    const timeframe = timeFrameInMinutes[selectedTimeFrame] || 1;

      // Map positions by normalized time
    const bulletMap = new Map();

    closedPositionsAll.filter((position) => position.symbol === selectedAuthSymbol).forEach((position) => {
      const positionTime = new Date(position.position_opened_at || position.created_at).getTime();

      if (isNaN(positionTime)) {
        console.warn("Skipping position due to invalid time:", position);
        return;
      }

      const normalizedTime = Math.floor(positionTime / (timeframe * 60 * 1000)) * (timeframe * 60 * 1000);

      const key = `${normalizedTime}-${position.direction}`;
      if (!bulletMap.has(key)) {
        bulletMap.set(key, []);
      }

      bulletMap.get(key).push(position);
    });

    bulletMap.forEach((positions, key) => {
      valueSeries.bullets.push(function (root, series, dataItem) {
        const candleStartTime = new Date(dataItem.dataContext.Date).getTime();
        const [timestamp, direction] = key.split('-');

        if (parseInt(timestamp) === candleStartTime) {
          const bulletsForTimestamp = [];

          positions.forEach((position, index) => {
            const isBuy = position.direction === "Buy";
            const svgPath = isBuy
              ? "M0,10 L5,0 L10,10 Z" // Upward arrow
              : "M0,0 L5,10 L10,0 Z"; // Downward arrow

            const dy = isBuy ? (index + 1) * 20 : -(index + 1) * 20;

            const tooltipHTML = `
              Closed: ${
                positions.length > 0
                  ? positions.map((p) => `<div>${p.position_id}</div>`).join("")
                  : "None"
              }
              Total Closed: ${positions.length}
            `;

            const arrow = am5.Graphics.new(root, {
              svgPath,
              fill: isBuy ? am5.color(selectedStyle.buyColor) : am5.color(selectedStyle.sellColor),
              stroke: am5.color(chartColors.text), // Updated to match theme $boldTextColor
              strokeWidth: 1,
              centerY: am5.p50,
              centerX: am5.p50,
              dy,
              tooltipHTML: tooltipHTML,
            });

            const bullet = am5.Bullet.new(root, {
              field: isBuy ? "high" : "low",
              sprite: arrow,
            });

            bulletsForTimestamp.push(bullet);
          });

          greenBullets2.push(...bulletsForTimestamp);
          return bulletsForTimestamp[0];
        }
      });
    });
  } else {
    greenBullets2.forEach((bullet) => bullet.dispose());
    greenBullets2 = [];
  }
};



let persistentBullets = [];

const createPersistentBullets = () => {
  const valueSeries = valueSeriesRef.current;

  if (!valueSeries) {
    // console.error("valueSeriesRef is not initialized");
    return;
  }

  // Clear existing bullets
  persistentBullets.forEach((bullet) => bullet.dispose());
  persistentBullets = [];

  if (showBullets) {
    console.log("Creating persistent bullets for all positions");

    const timeFrameInMinutes = {
      '1m': 1,
      '5m': 5,
      '15m': 15,
      '30m': 30,
      '1h': 60,
      '4h': 240,
      '1d': 1440,
    };

    const timeframe = timeFrameInMinutes[selectedTimeFrame] || 1;

    const bulletMap = new Map();

    // Combine open and closed positions
    const allPositions = [...openPositions, ...closedPositionsAll];

    allPositions
      .filter((position) => position.symbol === selectedAuthSymbol)
      .forEach((position) => {
        const positionTime = new Date(position.position_opened_at || position.created_at).getTime();

        if (isNaN(positionTime)) {
          console.warn("Skipping position due to invalid time:", position);
          return;
        }

        const normalizedTime = Math.floor(positionTime / (timeframe * 60 * 1000)) * (timeframe * 60 * 1000);

        const key = `${normalizedTime}-${position.direction}`;
        if (!bulletMap.has(key)) {
          bulletMap.set(key, []);
        }

        bulletMap.get(key).push(position);
      });

    console.log("Bullet Map for Persistent Bullets:", bulletMap);

    // Create bullets for each group
    bulletMap.forEach((positions, key) => {
      valueSeries.bullets.push(function (root, series, dataItem) {
        const candleStartTime = new Date(dataItem.dataContext.Date).getTime();
        const [timestamp, direction] = key.split('-');

        if (parseInt(timestamp) === candleStartTime) {
          const bulletsForTimestamp = [];

          // Filter open and closed positions at this timestamp
          const openPositionsAtTime = positions.filter(
            (p) => !closedPositionsAll.find((c) => c.position_id === p.position_id)
          );
          const closedPositionsAtTime = positions.filter((p) =>
            closedPositionsAll.find((c) => c.position_id === p.position_id)
          );

          positions.forEach((position, index) => {
            const isBuy = position.direction === "Buy";
            const svgPath = isBuy
              ? "M0,10 L5,0 L10,10 Z"
              : "M0,0 L5,10 L10,0 Z";

            const dy = isBuy ? (index + 1) * 20 : -(index + 1) * 20;

            const tooltipHTML = `
              Open:${
                openPositionsAtTime.length > 0
                  ? openPositionsAtTime
                      .map((p) => `<div>${p.position_id}</div>`)
                      .join("")
                  : "None"
              }
              Closed:${
                closedPositionsAtTime.length > 0
                  ? closedPositionsAtTime
                      .map((p) => `<div>${p.position_id}</div>`)
                      .join("")
                  : "None"
              }
              Total: ${
                positions.length
              } positions<br>${openPositionsAtTime.length === 0 ? "<strong>All positions closed</strong>" : ""}`;

            const arrow = am5.Graphics.new(root, {
              svgPath,
              fill: isBuy
                ? am5.color(selectedStyle.buyColor)
                : am5.color(selectedStyle.sellColor),
              stroke: am5.color(chartColors.text), // Updated to match theme $boldTextColor
              strokeWidth: 1,
              centerY: am5.p50,
              centerX: am5.p50,
              dy,
              tooltipHTML: tooltipHTML,
            });

            const bullet = am5.Bullet.new(root, {
              field: isBuy ? "high" : "low",
              sprite: arrow,
            });

            bulletsForTimestamp.push(bullet);
          });

          persistentBullets.push(...bulletsForTimestamp); // Save bullets
          return bulletsForTimestamp[0];
        }
      });
    });
  } else {
    persistentBullets.forEach((bullet) => bullet.dispose());
    persistentBullets = [];
  }
};


// useEffect(() => {
//   if (clickedPosition) {
//     createChartBulletClosePosition(clickedPosition);
//   }
// }, [chartInitialized, clickedPosition]);



// useEffect(() => {
//   if (root && valueSeriesRef.current && clickedPosition) {
//     createChartBulletClosePosition(clickedPosition);
//   }
// }, [root, valueSeriesRef.current, clickedPosition]);



// let savedClickedPosition = null;
// let orangeBullets = []; 

// const createChartBulletClosePosition = (clickedPosition) => {
//   if (!clickedPosition) {
//     console.warn("No clicked position provided.");
//     return;
//   }

//   const valueSeries = valueSeriesRef.current;

//   if (!valueSeries) {
//     console.error("valueSeriesRef is not initialized.");
//     return;
//   }
//   orangeBullets.forEach((bullet) => bullet.dispose());
//   orangeBullets = []; 

//   if (showBullets) {
//     const { id, symbol, closedAt, direction } = clickedPosition;

//     let targetCandle = null;

//     valueSeries.bullets.push(function (root, series, dataItem) {
//       const candleStartTime = new Date(dataItem.dataContext.Date).getTime();
//       const closedTime = new Date(closedAt).getTime();
//       const candleDuration = {
//         '1m': 60 * 1000,
//         '5m': 5 * 60 * 1000,
//         '15m': 15 * 60 * 1000,
//         '30m': 30 * 60 * 1000,
//         '1h': 60 * 60 * 1000,
//         '4h': 4 * 60 * 60 * 1000,
//         '1d': 24 * 60 * 60 * 1000,
//       }[selectedTimeFrame];

//       const isWithinCandle =
//         closedTime >= candleStartTime &&
//         closedTime < candleStartTime + candleDuration;

//       if (symbol === selectedAuthSymbol && isWithinCandle) {
//         // Save the target candle for zooming
//         targetCandle = dataItem.dataContext;

//         const isBuy = direction === "Buy";

//         const svgPath = isBuy
//           ? "M0,0 L5,10 L10,0 Z"  
//           : "M0,10 L5,0 L10,10 Z";

//         const bullet = am5.Graphics.new(root, {
//           svgPath: svgPath,
//           fill: isBuy ? am5.color("rgb(17, 209, 97)") : am5.color("rgb(245, 36, 36)"),
//           stroke: am5.color("#ffffff"),
//           strokeWidth: 1,
//           centerX: am5.p50,
//           centerY: am5.p50,
//           dy: isBuy ? -20 : 20,
//           tooltipText: `Position ID: ${id}\nDirection: ${direction}\nSymbol: ${symbol}\nClosed At: ${new Date(closedAt).toLocaleString()}`,
//         });

//         const newBullet = am5.Bullet.new(root, {
//           field: isBuy ? "high" : "low",
//           sprite: bullet,
//         });

//         orangeBullets.push(newBullet);
//         return newBullet;
//       }
//     });

//     if (targetCandle) {
//       const xAxis = valueSeries.get("xAxis");
//       if (xAxis) {
        
//         const targetDate = targetCandle.Date; 
//         const zoomStartDate = new Date(targetDate - 2 * 60 * 1000);
//         const zoomEndDate = new Date(targetDate + 2 * 60 * 1000); 

//         xAxis.zoomToDates(zoomStartDate, zoomEndDate); 
//         console.log("Chart zoomed to candle:", targetCandle);
//       } else {
//         console.error("xAxis is not initialized.");
//       }
//     }

//     // Draw the position line
//     // drawPositionLine(clickedPosition);
//   } else {
//     console.log("Clearing orange bullets");
//     orangeBullets.forEach((bullet) => bullet.dispose());
//     orangeBullets = [];
//   }
// };


// let positionLines = [];

// const drawPositionLine = (clickedPosition) => {
//   if (!clickedPosition) {
//     console.warn("No clicked position provided.");
//     return;
//   }

//   const valueSeries = valueSeriesRef.current;
//   if (!valueSeries) {
//     console.error("Value series is not initialized.");
//     return;
//   }

//   // Clear existing lines
//   positionLines.forEach((line) => line.dispose());
//   positionLines = [];

//   const { openedAt, closedAt, direction } = clickedPosition;

//   const openingDate = new Date(openedAt).getTime();
//   const closingDate = new Date(closedAt).getTime();

//   const data = valueSeries.data.values;

//   // Helper function to find the closest candle
//   const findClosestCandle = (targetTime) => {
//     return data.reduce((closest, candle) => {
//       const candleTime = candle.Date;
//       if (
//         !closest ||
//         Math.abs(targetTime - candleTime) < Math.abs(targetTime - closest.Date)
//       ) {
//         return candle;
//       }
//       return closest;
//     }, null);
//   };

//   // Get the opening and closing candles
//   const openingCandle = findClosestCandle(openingDate);
//   const closingCandle = findClosestCandle(closingDate);

//   if (!openingCandle || !closingCandle) {
//     console.warn("Opening or closing candle not found.");
//     return;
//   }

//   const xAxis = valueSeries.get("xAxis");
//   const yAxis = valueSeries.get("yAxis");

//   if (!xAxis || !yAxis) {
//     console.error("Axes are not initialized.");
//     return;
//   }

//   const root = valueSeries._root;

//   // Calculate line coordinates
//   const startX = xAxis.valueToPosition(openingCandle.Date) * root.container.width();
//   const startY = yAxis.valueToPosition(openingCandle.Close) * root.container.height();
//   const endX = xAxis.valueToPosition(closingCandle.Date) * root.container.width();
//   const endY = yAxis.valueToPosition(closingCandle.Close) * root.container.height();

//   if (isNaN(startX) || isNaN(startY) || isNaN(endX) || isNaN(endY)) {
//     console.error("Invalid line coordinates.");
//     return;
//   }

//   console.log("Start X, Y:", startX, startY);
//   console.log("End X, Y:", endX, endY);

//   // Draw the line
//   const line = am5.Graphics.new(root, {
//     stroke: am5.color(direction === "Buy" ? "rgb(17, 209, 97)" : "rgb(245, 36, 36)"),
//     strokeWidth: 2,
//     strokeDasharray: [3, 3],
//     layer: 100,
//   });

//   line.set("draw", (display) => {
//     display.moveTo(startX, startY);
//     display.lineTo(endX, endY);
//   });

//   valueSeries.bulletsContainer.children.push(line);
//   positionLines.push(line);

//   console.log("Line drawn successfully!");
// };






  // useEffect(() => {
  //   return () => {
  //     chartRef.current && chartRef.current.dispose();
  //   };
  // }, []);
function formatNumber(num, max_limit = 8) {
    let numStr = num.toString();
    
    if (numStr.length <= max_limit) {
       return num;
    } 

    let [integerPart, decimalPart] = numStr.split(".");

    if (integerPart.length >= max_limit) {
        return parseFloat(integerPart);
    }

    let allowedDecimals = max_limit - integerPart.length - 1;
    let truncatedDecimal = decimalPart.substring(0, allowedDecimals);

    let formattedNum = `${integerPart}.${truncatedDecimal}`;
    
    return parseFloat(formattedNum);
}

  // update price chart with live feeds
  const updateLiveFeedData = () => {
    if (
      platFromData.length > 0 &&
      platFromData[1] &&
      platFromData[1] != undefined &&
      platFromData[1] != 'undefined' &&
      stockChart2 != null &&
      currentLabel2 != null &&
      currentValueDataItem2 != null &&
      platFromData[1].s == selectedAuthSymbol
    ) {
      // Create a new data point based on the live feed data
      const liveFeedData = {
        Date: new Date(platFromData[1].t).getTime(), // Assuming the timestamp is in milliseconds
        Open: parseFloat(platFromData[1].o),
        High: parseFloat(platFromData[1].h),
        Low: parseFloat(platFromData[1].l),
        Close: parseFloat(platFromData[1].c),
        Volume: parseFloat(platFromData[1].v),
        askPrice: parseFloat(platFromData[1].ask),
      };
      // console.log("Live feed",liveFeedData);
      
      // Get the series for candlestick chart
      // console.log('valueSeries', stockChart2);
      let valueSeries = stockChart2.get('stockSeries');
      // console.log("st", valueSeries, liveFeedData);

      // Get the current timestamp
      let date = liveFeedData.Date; //Date.now();
      // console.log("Live Data Timestamp:", date);

      // Variable to store the new value for the live feed
      let value;
      let volume;

      // Get the last data object in the series
      let lastDataObject = valueSeries.data.getIndex(
        valueSeries.data.length - 1,
      );
      if (lastDataObject) {
        // Get the previous date and closing value from the last data object
        let previousDate = lastDataObject.Date;
        let previousValue = lastDataObject.Close;

        // set live price value
        value = liveFeedData.Close;

        volume = liveFeedData.Volume;

        // Get the high, low, and open values from the last data object
        let high = lastDataObject.High;
        let low = lastDataObject.Low;
        let open = lastDataObject.Open;

        // Check if a minute has passed since the previous data point
        if (am5.time.checkChange(date, previousDate, timeFrameChartSetup)) {
          open = value;
          high = value;
          low = value;

          let dObj1 = {
            Date: date,
            Close: value,
            Open: value,
            Low: value,
            High: value,
            Volume: volume,
          };

          // Add the new data object to the series
          valueSeries.data.push(dObj1);

          previousDate = date;

          currentChartDataRef.current.push(dObj1)

        } else {
          if (value > high) {
            high = value;
          }
          if (value < low) {
            low = value;
          }

          // Update the existing data object for the current minute
          let dObj2 = {
            Date: date,
            Close: value,
            Open: open,
            Low: low,
            High: high,
            Volume: volume,
          };

          // Replace the last data object in the series with the updated data
          valueSeries.data.setIndex(valueSeries.data.length - 1, dObj2);
        }
        // Update the live data label and animation if available
        if (currentLabel2) {
          currentValueDataItem2.set('value', value);
          // currentValueDataItemNew.set('value', liveFeedData.askPrice)
          currentValueDataItemNew.set('value', liveFeedData.askPrice);
          currentLabel2.set(
            'text',
            // formatPriceUptoDecimals(value, symbolInfo.digit),
            parseFloat(value),
            // formatNumber(value , symbolInfo?.digit)
          );
          currentLabelNew2.set(
            'text',
            parseFloat(liveFeedData.askPrice),
            // formatPriceUptoDecimals(liveFeedData.askPrice, symbolInfo.digit),
          );
          let bg = currentLabel2.get('background');
          let bg2 = currentLabelNew2.get('background');
          if (bg) {
            bg.set('fill', am5.color(selectedStyle.sellColor));
          }
          if (bg2) {
            bg2.set('fill', am5.color(selectedStyle.buyColor));
          }
        }
      }
    }
  };

  //show spinner while loading data
  if (loadingSymbolContext) {
    return <Spinner />;
  }

  return (
    <div className="Chart global-platfrom">
      <div id="chartcontrols"></div>
      <div id="chartdiv"></div>
    </div>
  );
};

export default Chart;
